var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSmiling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C9FE9A",
    fillRule: "nonzero",
    d: "M29.667 3H3a2 2 0 0 0-2 2v18.071a1.945 1.945 0 0 0 2 1.93h4v5.333a.667.667 0 0 0 1.046.548l8.496-5.881h13.125a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-22 8.444a3.667 3.667 0 0 1 7.333 0 1 1 0 1 1-2 0 1.667 1.667 0 0 0-3.333 0 1 1 0 1 1-2 0zm3.955 5.31a1 1 0 0 1 1.413 0 4.77 4.77 0 0 0 6.587 0 1 1 0 0 1 1.413 1.414 6.657 6.657 0 0 1-9.413 0 1 1 0 0 1 0-1.414zm8.045-5.31a1 1 0 1 1-2 0 3.667 3.667 0 0 1 7.334 0 1 1 0 1 1-2 0 1.667 1.667 0 0 0-3.334 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSmiling);
export default __webpack_public_path__ + "static/media/message-smiling.db9311b643a4d9265e86e74fc1156120.svg";
export { ForwardRef as ReactComponent };